export function getUpdatedTemplates(modified, original, json) {
  return Object.keys(modified)
    .map(template =>
      areNotEqual(template, modified, original, json)
        ? { [template]: modified[template] }
        : {}
    )
    .reduce((acc, obj) => Object.assign(acc, obj), {});
}

function areNotEqual(template, modified, original, json = []) {
  return json.includes(template)
    ? JSON.stringify(modified[template]) !== JSON.stringify(original[template])
    : modified[template] !== original[template];
}
